export default {
	国家: '国',
	前缀: 'プレフィックス',
}
